// export const apiUrl= process.env.REACT_APP_API_URL;
export const apiUrl = "https://drakaroltalaveraapi.rocazit.com";
/* export const apiUrl = "http://localhost:8000"; */
export const drName = "Dr. Karol Talavera";
export const specificConfigurationDataUrl =
  apiUrl + "/api/v1/configuracion/getdoctor";